import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import { render, hydrate } from 'preact';
import renderToString from 'preact-render-to-string';
import { MetadataCard } from '../metadata/MetadataCard';
import { caption_source, infos_to_display, flat_orientation } from '../settings';

export const initFlatCaption = (lightbox) => {
  const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
    type: flat_orientation,
    captionContent: (slide) => {
      const image = slide.data;

      const caption_text = image.caption || (image.meta && image.meta.caption);
      const description_text = image.description || (image.meta && image.meta.description);
      const caption = caption_source === 'description' ? description_text : caption_text;
      
      // Update image object with the correct caption to be used by Description component
      image.caption = caption;

      // Render to string for the plugin
      const html = renderToString(
        <MetadataCard 
          image={image}
          onCloseClick={() => {}} 
          onCollapsedChange={() => {}} 
        />
      );
      
      // Wrap in a container with unique ID and classes
      return `<div id="mwl-caption-${image.id}" class="mwl-flat-caption-container mwl__metadata mwl__metadata--flat mwl__metadata--flat--${flat_orientation}">${html}</div>`;
    }
  });

  lightbox.on('init', () => {
    const pswp = lightbox.pswp;

    // Hide caption during opening animation, then fade it in
    pswp.on('openingAnimationStart', () => {
      const captionElement = pswp.element.querySelector('.pswp__dynamic-caption');
      if (captionElement) {
        captionElement.style.opacity = '0';
      }
    });

    pswp.on('openingAnimationEnd', () => {
      const captionElement = pswp.element.querySelector('.pswp__dynamic-caption');
      if (captionElement) {
        // Use a small delay to ensure the caption is positioned correctly
        setTimeout(() => {
          captionElement.style.transition = 'opacity 300ms ease';
          captionElement.style.opacity = '1';
        }, 50);
      }
    });

    // Prevent propagation of click events from caption to underlying elements
    const preventDrag = (e) => {
      e.stopPropagation();
    };
    
    const preventCaptionClickPropagation = () => {
      const slide = pswp.currSlide;
      if (!slide || !slide.data) return;
      
      const uniqueId = `mwl-caption-${slide.data.id}`;
      const captionContainer = document.getElementById(uniqueId);
      
      if (captionContainer) {
        captionContainer.setAttribute('aria-label', 'Image caption and metadata');

        // Remove old listeners to prevent duplicates
        captionContainer.removeEventListener('pointerdown', preventDrag, true);
        captionContainer.removeEventListener('touchstart', preventDrag, true);
        captionContainer.removeEventListener('mousedown', preventDrag, true);
        
        // Add event listeners in capture phase to ensure they fire first
        captionContainer.addEventListener('pointerdown', preventDrag, true);
        captionContainer.addEventListener('touchstart', preventDrag, true);
        captionContainer.addEventListener('mousedown', preventDrag, true);
      }
    };

    pswp.on('contentInit', preventCaptionClickPropagation);


    const hydrateCaption = () => {
      const slide = pswp.currSlide;
      if (!slide || !slide.data) return;
      
      const image = slide.data;
      const uniqueId = `mwl-caption-${image.id}`;
      
      // Use setTimeout to ensure the DOM is updated by the plugin
      setTimeout(() => {
          const el = document.getElementById(uniqueId);
          if (el) {
              const handleCollapsedChange = (isCollapsed) => {
                  el.classList.toggle('collapsed', isCollapsed);
              };

              hydrate(
                  <MetadataCard 
                    image={image}
                    onCloseClick={() => {}} 
                    onCollapsedChange={handleCollapsedChange} 
                  />, 
                  el
              );
              
              // Re-apply event listeners after hydration
              preventCaptionClickPropagation();
          }
          
      }, 50);
    };

    pswp.on('change', hydrateCaption);
    pswp.on('resize', hydrateCaption);
  });
};
